import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';
import { CopiedType } from '../enums/copied-type';

@Injectable({
  providedIn: 'root',
})
export class CopyInformationService {
  constructor(private toastService: ToastService) {}

  copy(
    data: string | string[] | object[],
    copiedType: CopiedType | null = null,
    title = '',
    isLesson = true
  ): void {
    let textToCopy = title ? title + '\n' : '';

    if (typeof data === 'string') {
      textToCopy = textToCopy + data;
    } else if (Array.isArray(data)) {
      textToCopy =
        textToCopy +
        data
          .map((item) =>
            typeof item === 'string' ? item : Object.values(item).join('\n')
          )
          .join('\n');
    } else if (typeof data === 'object' && data !== null) {
      textToCopy = textToCopy + Object.values(data).join('\n');
    }
    this.writeText(textToCopy).then(
      () => {
        let keyTranslate = '';
        if (!isLesson) {
          if (copiedType === CopiedType.IA) {
            keyTranslate = 'KNOWLEDGE.PILLS_SIMILAR_PROJECTS.TOOLTIP_COPY_IA';
          }

          if (copiedType === CopiedType.CONVERGENCIA) {
            keyTranslate = 'KNOWLEDGE.PILLS_KNOWLEDGE.COPY_CONVERGENCIA';
          }
        } else {
          keyTranslate = 'LESSONCOPYFLOW.COPYCONFIRMED';
        }
        this.toastService.show(keyTranslate, 'success');
      },
      (err) => {
        console.error('Error copying information:', err);
        this.toastService.show(err, 'error');
      }
    );
  }

  private writeText(text: string): Promise<void> {
    if (navigator.clipboard?.writeText) {
      return Promise.resolve()
        .then(() => navigator.clipboard.writeText(text))
        .catch(() => this.writeTextFallback(text));
    }

    return this.writeTextFallback(text);
  }

  private async writeTextFallback(text: string): Promise<void> {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();

    try {
      if (!document.execCommand('copy')) {
        return Promise.reject(new Error('Unable to copy text to clipboard'));
      }
      return Promise.resolve();
    } finally {
      document.body.removeChild(textarea);
    }
  }
}
